import styled from 'styled-components'

export const Item = styled.a(({ theme }) => ({
    fontSize: 16,
    fontWeight: 400,
    listStyle: 'none',
    lineHeight: '150%',
    textDecoration: 'underline',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    color: theme.color.brandPrimary.light,
    cursor: 'pointer',

    [theme.breakpoint.lg()]: {
        fontSize: 18
    }
}))

export const List = styled.ul(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    margin: '40px 0'
}))